/*** IMPORTS FROM imports-loader ***/
var define = false;

import $ from 'jquery';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
// import { ScrollSmoother } from "gsap/ScrollSmoother";
gsap.registerPlugin(ScrollTrigger);
import { animateOnScroll } from './modules/animateOnScroll.js';
import imagesLoaded from 'imagesloaded';
import { mobileNav } from './modules/mobileNav';
// import { pageFade } from './modules/pageFade.js'; doesn't work in safari
import { workPopup } from './modules/workPopup';
import { testimonialsSlider } from './modules/testimonialsSlider';
import { house } from './modules/house.js';
import { howReel } from './modules/reel.js';
import { caseStudyReel } from './modules/reel.js';
import { extraordinaryReel } from './modules/reel.js';
// import { animateLogos } from './modules/animateLogos.js';
import { sectionLabel } from './modules/sectionLabel.js';
import { services } from './modules/services.js';
import { people } from './modules/people.js';
import { jobsToggles } from './modules/jobs.js';
import { wins } from './modules/wins.js';
import Cursor from "./modules/cursor";
import Magnetic from "./modules/magnetic";
import { marqueeText } from './modules/marqueeText.js';
import { initInlineVideos } from './modules/inlineVideos.js';
import { heroReel } from './modules/reel.js';
import { contactForm } from './modules/contactForm.js';
import { popup } from './modules/popup.js';
// import { homeHeroVideo } from './modules/homeHeroVideo.js';
// import { desktopReel } from './modules/reel.js';
// import { mobileReel } from './modules/reel.js';
import { splitTitle } from './modules/splitTitle.js';
import { tracking } from './modules/tracking.js';
import { cardTransition } from './modules/cardTransition.js';
// import { heroSlider } from './modules/heroSlider.js';

if (window.innerWidth < 960) {
  $(window).scroll(function () {
    if ($(this).scrollTop() > 5) {
      $("body").addClass("scrolled");
    } else {
      $("body").removeClass("scrolled");
    }
  });
} else {
  $('.fullView').scroll(function () {
    if ($(this).scrollTop() > 5) {
      $("body").addClass("scrolled");
    } else {
      $("body").removeClass("scrolled");
    }
  });
}

// Hide nav on scroll down
const showAnim = gsap.from('.hamburger', {
  opacity: 0,
  paused: true,
  duration: 0.2
}).progress(1);

tracking();

var fullViewExists = document.querySelector('.fullView');
if (fullViewExists) {
  if (window.innerWidth > 960) {
    ScrollTrigger.create({
      // scroller: smoother,
      scroller: '.fullView',
      start: "top top",
      end: 99999,
      onUpdate: (self) => {
        self.direction === -1 ? showAnim.play() : showAnim.reverse()
      }
    });
  } else {
    ScrollTrigger.create({
      // scroller: smoother,
      start: "top top",
      end: 99999,
      onUpdate: (self) => {
        self.direction === -1 ? showAnim.play() : showAnim.reverse()
      }
    });
  }
}

// 1 ////////////////////////////////////////
// Load stuff after all the images in the body load
imagesLoaded(document.querySelector('body'), { background: true }, function (instance) {

  // then set up all scroll-based animations
  if (fullViewExists) {
    animateOnScroll();
  }

  // get the height of .victory__title
  var titleHeightNeeded = document.querySelector('.victory__title');
  if (titleHeightNeeded) {
    if (window.height > 960) {
      const titleHeight = $('.victory__title').outerHeight(true);
      $('.victory__col--right').css('padding-top', titleHeight + 'px');
    }
  }

  // let us know when you're ready
  setTimeout(() => {
    // do a scrolltrigger refresh for good measure
    // ScrollTrigger.refresh();

    // then, we're ready
    $('body').addClass('ready');

    // then our page fade can work, I think
    // pageFade();
  }, 500);

});

// 2 ////////////////////////////////////////
// Don't load on mobile
function is_touch_enabled() {
  return ('ontouchstart' in window) ||
    (navigator.maxTouchPoints > 0) ||
    (navigator.msMaxTouchPoints > 0);
}

if (!is_touch_enabled()) {

  // Set up cursor
  const cursor = new Cursor();
  $('[data-magnetic]').each(function () { new Magnetic(this); });

  // Custom Parallax only on desktop
  var customParallaxExists = document.querySelector('.parallax-bg');
  if (customParallaxExists && (window.innerWidth > 960)) {
    const scrollContainer = document.querySelector('.fullView');
    const parallaxImages = document.querySelectorAll('.parallax-bg-image');

    function updateParallax() {
      const scrollY = scrollContainer.scrollTop;

      parallaxImages.forEach((img, index) => {
        const container = img.closest('.fullView__section');
        const rect = container.getBoundingClientRect();

        // Only apply parallax if slide is visible
        if (rect.top < window.innerHeight && rect.bottom > 0) {
          const speed = 0.7;
          const yPos = -rect.top * speed;
          img.style.transform = `translateY(${yPos}px)`;
        }
      });
    }

    // Listen to scroll on container, not window
    scrollContainer.addEventListener('scroll', updateParallax, { passive: true });
    // Initial call
    updateParallax();
  }

  var splitTitleExists = document.querySelector('.splitTitle');
  if (splitTitleExists) {
    splitTitle();
  }

  document.querySelectorAll('.parallax').forEach(el => {
    const speed = parseFloat(el.dataset.speed) || 0.2;
    gsap.to(el, {
      yPercent: speed * 100,       // move up to speed×100% of its height
      ease: 'none',
      scrollTrigger: {
        trigger: el,
        scroller: '.fullView',
        start: 'top bottom',        // when the top of el hits the bottom of viewport
        end: 'bottom top',          // until the bottom of el hits the top of viewport
        scrub: true                 // link animation progress to scroll position
      }
    });
  });


} else {
  $('body').addClass('touch');
}


// 3 /////////////////////////////////////////
// Load everything else
mobileNav();
contactForm();

// var reelExists = document.querySelector('.reelContainer');
// if (reelExists) {
//   desktopReel();
//   reelExists.classList.add('nonTouch');
// }

// Home page stuff
var isHomePage = document.querySelector('body.home');
if (isHomePage) {
  house();
}

var popupsExist = document.querySelector('.popupLink');
if (popupsExist) {
  popup();
}

var reelExists = document.querySelector('.reel__reelContainer');
if (reelExists) {
  heroReel();
}

var howReelExists = document.querySelector('.how__reelContainer');
if (howReelExists) {
  howReel();
  howReelExists.classList.add('nonTouch');
}

var caseStudyReelExists = document.querySelector('.caseStudy__reelContainer');
if (caseStudyReelExists) {
  caseStudyReel();
}

var inlineVideosExists = document.querySelector('.inlineVideo');
if (inlineVideosExists) {
  initInlineVideos();
}

var extraOrdinaryReelExists = document.querySelector('.extraordinary__reelContainer');
if (extraOrdinaryReelExists) {
  extraordinaryReel();
}

var testimonialsSliderExists = document.querySelector('.testimonials__slider');
if (testimonialsSliderExists) {
  testimonialsSlider();
  // ScrollTrigger.create({
  //   trigger: ".testimonials",
  //   start: "top 30%",
  //   end: "bottom -500%",
  //   toggleClass: {
  //     targets: "body",       // ← can be selector, element, or array of them
  //     className: "dark"
  //   },
  //   // markers:     true
  // });
}

var workPopupExists = document.querySelector('.work__link');
if (workPopupExists) {
  workPopup();
}

// var animateLogosExists = document.querySelector('.winners__logo');
// if (animateLogosExists) {
//   animateLogos();
// }

var sectionLabelExists = document.querySelector('.sectionLabel');
if (sectionLabelExists) {
  sectionLabel();
}

var servicesExists = document.querySelector('.services');
if (servicesExists) {
  services();
}

if (document.querySelector('.team__link')) {
  cardTransition();
}

var peopleExists = document.querySelector('.team__popupLink');
if (peopleExists) {
  people();
}

var jobsExists = document.querySelector('.join__titleWrap');
if (jobsExists) {
  jobsToggles();
}

// var winsExists = document.querySelector('.winning__toggle');
// if (winsExists) {
//   wins();
// }

// var heroSliderExists = document.querySelector('.heroSlider');
// if (heroSliderExists) {
//   heroSlider();
// }

var marqueeExists = document.querySelector('.marquee');
if (marqueeExists) {
  marqueeText();
}

// Refire stuff on window resize
// var timeout = false, // holder for timeout id
//     delay   = 250; // delay after event is "complete" to run callback

// // window.resize event listener
// window.addEventListener('resize', function () {
//   // clear the timeout
//   clearTimeout(timeout);
//   // start timing for event "completion"
//   timeout = setTimeout(function () {
//     ScrollTrigger.refresh();
//   }, delay);
// });



// Dynamic scroll snap handler for footer
class ScrollSnapManager {
  constructor() {
    this.fullView = document.querySelector('.fullView');
    this.footer = document.querySelector('.siteFooter');
    this.sections = document.querySelectorAll('.fullView__section:not(.siteFooter)');
    this.isFooterScrolling = false;
    this.scrollTimeout = null;

    this.init();
  }

  init() {
    if (!this.fullView || !this.footer) return;

    // Set initial scroll snap
    this.fullView.style.scrollSnapType = 'y mandatory';

    // Listen for scroll events
    this.fullView.addEventListener('scroll', this.handleScroll.bind(this));

    // Listen for wheel events to detect scroll direction and intent
    this.fullView.addEventListener('wheel', this.handleWheel.bind(this), { passive: false });
  }

  handleScroll() {
    const scrollTop = this.fullView.scrollTop;
    const viewportHeight = window.innerHeight;
    const footerTop = this.footer.offsetTop;
    const totalHeight = this.fullView.scrollHeight;

    // Calculate distance to footer
    const distanceToFooter = footerTop - (scrollTop + viewportHeight);

    // If we're close to the footer (within 100px), disable snap
    if (distanceToFooter < 100 && !this.isFooterScrolling) {
      this.disableSnap();
    }
    // If we're scrolling back up and away from footer, re-enable snap
    else if (distanceToFooter > 200 && this.isFooterScrolling) {
      this.enableSnap();
    }
  }

  handleWheel(e) {
    const scrollTop = this.fullView.scrollTop;
    const viewportHeight = window.innerHeight;
    const footerTop = this.footer.offsetTop;
    const lastSectionBottom = this.sections[this.sections.length - 1].offsetTop + this.sections[this.sections.length - 1].offsetHeight;

    // If we're at the last section and scrolling down, prepare for footer
    if (scrollTop + viewportHeight >= lastSectionBottom - 50 && e.deltaY > 0) {
      this.disableSnap();
    }
  }

  disableSnap() {
    if (!this.isFooterScrolling) {
      this.fullView.style.scrollSnapType = 'none';
      this.isFooterScrolling = true;
      console.log('Scroll snap disabled for footer');
    }
  }

  enableSnap() {
    if (this.isFooterScrolling) {
      this.fullView.style.scrollSnapType = 'y mandatory';
      this.isFooterScrolling = false;
      console.log('Scroll snap enabled');
    }
  }

  // Method to manually scroll to footer (for footer links, etc.)
  scrollToFooter() {
    this.disableSnap();
    this.footer.scrollIntoView({ behavior: 'smooth' });
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  const scrollSnapManager = new ScrollSnapManager();

  // Optional: Add click handlers for any footer navigation links
  const footerLinks = document.querySelectorAll('a[href="#footer"], .scroll-to-footer');
  footerLinks.forEach(link => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      scrollSnapManager.scrollToFooter();
    });
  });
});

